export default {"src":"/_next/static/media/picsart.c8403ac7.svg","height":256,"width":256,"blurWidth":0,"blurHeight":0};